module.exports = __webpack_public_path__ + "static/img/16.3c3e1e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/honour/16.jpg
// module id = 2G9d
// module chunks = 1